export default "__VITE_ASSET__l9P5dYas__"